module.exports = __webpack_public_path__ + "img/8.424d38fa.svg";